import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChevronLeft = () => {
  return (
    <g>
      <path d="m11.02 14.79a.7467.7467 0 0 1 -.53-.22l-6.04-6.0395a.75.75 0 0 1 0-1.0605l6.0391-6.04a.75.75 0 1 1 1.0609 1.06l-5.509 5.51 5.509 5.51a.75.75 0 0 1 -.53 1.28z" />
    </g>
  );
};

export default withIcon(IconChevronLeft);
